// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  visiotexBaseURL: 'https://visiotex.texa.fr',
  API_KEY_H264: '46159762',
  API_KEY_VP8: '44930212',
  GOOGLE_ANALYTICS_TRACKING_ID: 'UA-121789978-1'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts